import GenerateCampaignModalLayout from "../../GenerateCampaign/GenerateCampaignModalLayout";
import GenerateCampaignFormTikTok from "./GenerateCampaignFormTikTok";

const GenerateCampaignTikTok = ({
  initialData = {},
  modalOpen,
  onCloseModal,
  campaignID,
  context,
  onCallbackSave = () => {},
  verifyBlockAlert = true,
}) => {
  return (
    <GenerateCampaignModalLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
    >
      <GenerateCampaignFormTikTok
        initialData={initialData}
        campaignID={campaignID}
        context={context}
        onCallbackSave={onCallbackSave}
        verifyBlockAlert={verifyBlockAlert}
      />
    </GenerateCampaignModalLayout>
  );
};

export default GenerateCampaignTikTok;
